import { css } from "@emotion/core"
import { graphql } from "gatsby"
import { RichText } from "prismic-reactjs"
import React from "react"
import { Container, Layout, Section, Seo } from "../components"
import { linkResolver } from "../utils/linkResolver"

export const query = graphql`
  query($uid: String!) {
    prismic {
      privacy(uid: $uid, lang: "en-us") {
        seo_title
        seo_description
        seo_image
        body
      }
      nav(lang: "en-us", uid: "nav") {
        logo
        links {
          link {
            ...PrismicLinkPrivacy
          }
          text
        }
        cta_text
        cta_link {
          ...PrismicLinkPrivacy
        }
      }
      faq(lang: "en-us", uid: "faqs") {
        heading
        items {
          answer
          question
        }
        faq_expand_prompt
        chat_support_prompt
        chat_support_image
        chat_support_heading
      }
      footer(lang: "en-us", uid: "footer") {
        logo
        nav_links {
          link {
            ...PrismicLinkPrivacy
          }
          text
        }
        subscribe_form_heading
        subscribe_form_input
        subscribe_form_prompt
        info_links {
          link {
            ...PrismicLinkPrivacy
          }
          text
        }
      }
    }
  }
  fragment PrismicLinkPrivacy on PRISMIC__Linkable {
    _linkType
    ... on PRISMIC_Demo {
      _meta {
        uid
        type
      }
    }
    ... on PRISMIC_Faq {
      _meta {
        uid
        type
      }
    }
    ... on PRISMIC_Features {
      _meta {
        uid
        type
      }
    }
    ... on PRISMIC_Testimonials {
      _meta {
        uid
        type
      }
    }
    ... on PRISMIC_Contact {
      _meta {
        uid
        type
      }
    }
    ... on PRISMIC_Home {
      _meta {
        uid
        type
      }
    }
    ... on PRISMIC_Privacy {
      _meta {
        uid
        type
      }
    }
    ... on PRISMIC_Signup {
      _meta {
        uid
        type
      }
    }
    ... on PRISMIC_Terms {
      _meta {
        uid
        type
      }
    }
    ... on PRISMIC_About {
      _meta {
        uid
        type
      }
    }
    ... on PRISMIC_Footer {
      _meta {
        uid
        type
      }
    }
    ... on PRISMIC_Pricing {
      _meta {
        uid
        type
      }
    }
    ... on PRISMIC__ExternalLink {
      url
    }
    ... on PRISMIC__ImageLink {
      url
    }
    ... on PRISMIC__FileLink {
      url
    }
  }
`

const PrivacyPage = props => {
  const { privacy } = props.data.prismic

  console.log(props)

  return (
    <Layout {...props}>
      <Section css={styles.all}>
        <Seo {...privacy} />
        <Container style={{ maxWidth: 800 }} className="large">
          {RichText.render(privacy.body, linkResolver)}
        </Container>
      </Section>
    </Layout>
  )
}

const styles = {
  all: css`
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    li {
      margin: 20px 0;
    }
  `
}

export default PrivacyPage
